import React from 'react';
import styled, { css } from 'styled-components';

import { PageTabs } from './PageTabs';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HeaderWrapper = styled.div<{ hasTabs?: boolean }>`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  justify-content: space-between;
  padding-bottom: 16px;

  ${({ hasTabs }) =>
    hasTabs
      ? css`
          margin-bottom: 0px;
        `
      : css`
          border-bottom: 1px solid #e5e5e5;
          margin-bottom: 24px;
        `}
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Title = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: -0.4px;
  color: var(--gray-90);
`;

const Description = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: -0.4px;
  color: #939090;
`;

type Props = {
  title: string;
  description?: string;
  children?: React.ReactNode;
  tabs?: {
    label: string;
    content: React.ReactNode;
  }[];
};

const HeaderOptionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const PageHeader: React.FC<Props> = ({ children, title, description, tabs }) => {
  return (
    <Container>
      <HeaderWrapper hasTabs={!!tabs}>
        <TitleWrapper>
          <Title>{title}</Title>
          {description && <Description>{description}</Description>}
        </TitleWrapper>
        <HeaderOptionsWrapper>{children}</HeaderOptionsWrapper>
      </HeaderWrapper>
      {tabs && <PageTabs tabs={tabs} />}
    </Container>
  );
};
